export default (theme: any) => ({
    mailElement: {
        backgroundColor: '#f4f4fb !important',
        margin: '8px 0px',
        padding: '6px',
    },

    blueIcon: {
        color: theme.palette.primary.main,
    },

    icon: {
        minWidth: '34px',
    },
})
